import React, { PropsWithChildren } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: 8,
      color: theme.palette.primary.main,
      fontSize: 14,
      fontWeight: 700,
      [theme.breakpoints.up("md")]: {
        fontSize: 20,
      },
    },
  })
)
export default function SectionCategory({ children }: PropsWithChildren<{}>) {
  const classes = useStyles()
  return <Typography className={classes.root}>{children}</Typography>
}
